/**
 * The columns the segments board has.
 *
 * Here rather than in the front end for the same reason `BASE_COLUMNS` is: the
 * board draws this list and orders by it, and the sort a person chooses names
 * one of these ids. A second list in the browser would be a second answer to
 * what a segment has.
 *
 * A segment has no declared fields, so unlike the contacts board this list is
 * the whole of it. The four are what a segment *is*: what it is called, what it
 * asks for, and when it appeared and last changed.
 */
export const SEGMENT_COLUMNS = [
    { id: 'name', defaultLabel: 'Name', sortable: true, fixed: true },
    { id: 'asks', defaultLabel: 'Asks for', sortable: false, fixed: false },
    /**
     * How many contacts are connected to it.
     *
     * Not sortable: the count is worked out per row by the database and ordering
     * by it would mean counting every segment before choosing any, which is a
     * different query from the one that draws the board.
     */
    { id: 'connected', defaultLabel: 'Connected', sortable: false, fixed: false },
    { id: 'created', defaultLabel: 'Created', sortable: true, fixed: false },
    { id: 'changed', defaultLabel: 'Last changed', sortable: true, fixed: false },
];
/** Whether an id names one of these, which is what a rename may be stored for. */
export function isSegmentColumn(id) {
    return SEGMENT_COLUMNS.some((column) => column.id === id);
}
//# sourceMappingURL=segmentColumns.js.map